// eslint-disable-next-line

function FooterContent(){
    return(
        <>
        <footer className="fv-footer astro-dwl4onjj" data-testid="footer">
  <div className="fv-footer__container wrapper fs-14 wrapper fs-14 fv-footer__container astro-dwl4onjj">
    <div className="fv-footer__item fv-footer__about-fever astro-dwl4onjj">
      <p className="fv-footer__title fs-18 astro-dwl4onjj">Über Fever</p>
      <ul className="fv-footer__list astro-dwl4onjj">
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-testid="footer-press-link"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://newsroom.feverup.com/de-DE/"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Presse{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="http://careers.feverup.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-fever-zone-link"
          >
            {" "}
            Wir stellen ein!{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-icp-link"
            href="https://docs.google.com/document/d/e/2PACX-1vTimFJf1ZCY3ynQLHFJLnc_vLkXutN6_ZU66AyYsKJLFmb7bkCKykfUaFXMUAQaJEsl2v4I0uFbR3Ww/pub"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Impressum{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://giftcard.feverup.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-gift-cards-link"
          >
            {" "}
            Geschenkgutscheine{" "}
          </a>{" "}
        </li>
      </ul>
    </div>
    <div className="fv-footer__item fv-footer__work-with-us astro-dwl4onjj">
      <p className="fv-footer__title fs-18 astro-dwl4onjj">Partner werden</p>
      <ul className="fv-footer__list astro-dwl4onjj">
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://partners.feverup.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-fever-zone-link"
          >
            {" "}
            Fever Zone{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-create-event-link"
            href="https://business.feverup.com/de"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Veröffentliche dein Event{" "}
          </a>
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-affiliates-link"
            href="https://affiliates.feverup.com"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Affiliate-Programm{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-become-influencer-link"
            href="https://influencers.feverup.com"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Werde Influencer:in{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-become-ambassador-link"
            href="https://ambassadors.feverup.com"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Werde Botschafter:in{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-corporate-link"
            href="https://corporate.feverup.com"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Firmenevents &amp; -vorteile{" "}
          </a>
        </li>
      </ul>
    </div>
    <div className="fv-footer__item fv-footer__follow-us astro-dwl4onjj">
      <p className="fv-footer__title fs-18 astro-dwl4onjj">Folge uns</p>
      <ul className="fv-footer__list astro-dwl4onjj">
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://www.facebook.com/feverup/"
            target="_blank"
            rel="noreferrer"
            aria-label="facebook"
          >
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
              focusable="false"
              className="svg-inline--fa fa-square-facebook fa-fw astro-dwl4onjj svelte-1ipid5s"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
              ></path>
            </svg>{" "}
            Facebook{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://x.com/fever_gl"
            target="_blank"
            rel="noreferrer"
            aria-label="twitter"
          >
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
              focusable="false"
              className="svg-inline--fa fa-square-x-twitter fa-fw astro-dwl4onjj svelte-1ipid5s"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"
              ></path>
            </svg>{" "}
            X (Twitter){" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://www.instagram.com/fever_global/"
            target="_blank"
            rel="noreferrer"
            aria-label="instagram"
          >
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
              focusable="false"
              className="svg-inline--fa fa-instagram fa-fw astro-dwl4onjj svelte-1ipid5s"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
              ></path>
            </svg>{" "}
            Instagram{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://www.tiktok.com/@feverup"
            target="_blank"
            rel="noreferrer"
            aria-label="tiktok"
          >
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
              focusable="false"
              className="svg-inline--fa fa-tiktok fa-fw astro-dwl4onjj svelte-1ipid5s"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
              ></path>
            </svg>{" "}
            TikTok{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://www.linkedin.com/company/fever-up"
            target="_blank"
            rel="noreferrer"
            aria-label="linkedin"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
              focusable="false"
              className="svg-inline--fa fa-linkedin fa-fw astro-dwl4onjj svelte-1ipid5s"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
              ></path>
            </svg>{" "}
            LinkedIn{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            href="https://www.youtube.com/c/feverup"
            target="_blank"
            rel="noreferrer"
            aria-label="youtube"
          >
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
              focusable="false"
              className="svg-inline--fa fa-youtube fa-fw astro-dwl4onjj svelte-1ipid5s"
              viewBox="0 0 576 512"
            >
              <path
                fill="currentColor"
                d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
              ></path>
            </svg>{" "}
            YouTube{" "}
          </a>{" "}
        </li>
      </ul>
    </div>
    <div className="fv-footer__item fv-footer__discover astro-dwl4onjj">
      <p className="fv-footer__title fs-18 astro-dwl4onjj">Entdecken</p>
      <ul className="fv-footer__list astro-dwl4onjj">
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            data-use-query-params=""
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-discover-link"
            href="https://feverup.com/de/berlin/venue"
          >
            {" "}
            Veranstaltungsorte in Berlin{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            data-use-query-params=""
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-discover-link"
            href="https://feverup.com/de/country/germany"
          >
            {" "}
            Deutschland{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            data-use-query-params=""
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-discover-link"
            href="https://feverup.com/de/berlin/when/today"
          >
            {" "}
            Heute{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            data-use-query-params=""
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-discover-link"
            href="https://feverup.com/de/berlin/when/tomorrow"
          >
            {" "}
            Morgen{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            data-use-query-params=""
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-discover-link"
            href="https://feverup.com/de/berlin/when/this-week"
          >
            {" "}
            Diese Woche{" "}
          </a>{" "}
        </li>
        <li className="fv-footer__item astro-dwl4onjj">
          {" "}
          <a
            data-use-query-params=""
            className="fv-footer__link astro-dwl4onjj"
            data-footer-link-clicked=""
            data-footer-link-city="Berlin"
            data-testid="footer-discover-link"
            href="https://feverup.com/de/berlin/when/this-weekend"
          >
            {" "}
            Dieses Wochenende{" "}
          </a>{" "}
        </li>
      </ul>
    </div>
    <div className="fv-footer__item fv-footer__support astro-dwl4onjj">
      <p className="fv-footer__title fs-18 astro-dwl4onjj">24/7-Support</p>
      <ul className="fv-footer__list astro-dwl4onjj">
        <li className="fv-footer__item astro-dwl4onjj"></li>
      </ul>
    </div>
    <div
      className="fv-footer__item fv-footer__description astro-dwl4onjj"
      data-testid="footer-description"
    >
      <picture className="astro-dwl4onjj">
        <source
          type="image/svg+xml"
          srcSet="/_astro/fever-logo-white.CoghI004.svg"
          className="astro-dwl4onjj"
        />
        <source
          type="image/png"
          srcSet="/_astro/fever-logo-white.-BJVRSGT.png"
          className="astro-dwl4onjj"
        />{" "}
        <img
          src="/_image?href=%2F_astro%2Ffever-logo-white.-BJVRSGT.png&w=78&h=24&f=webp"
          className="fv-footer__logo astro-dwl4onjj"
          data-testid="footer-logo"
          loading="lazy"
          alt="Fever logo"
          width={78}
          height={24}
          decoding="async"
        />
      </picture>
      <p className="fv-footer__title fs-18 astro-dwl4onjj">
        Du hast die App noch nicht?
      </p>
      <p className="astro-dwl4onjj">
        Entdecke bevorstehende Erlebnisse und Events, die am besten zu dir
        passen.
      </p>
      <ul className="fv-footer__legal-info astro-dwl4onjj"> </ul>
      <div className="fv-footer__app-store astro-dwl4onjj">
        {" "}
        <a
          data-footer-link-clicked=""
          data-footer-link-city="Berlin"
          href="https://apps.apple.com/de/app/fever-local-events-tickets/id497702817"
          rel="noreferrer"
          target="_blank"
          className="astro-dwl4onjj"
        >
          {" "}
          <img
            src="/_astro/new-app-store-button.C0zsR03z.svg"
            alt="App Store"
            loading="lazy"
            className="astro-dwl4onjj"
          />{" "}
        </a>{" "}
        <a
          data-footer-link-clicked=""
          data-footer-link-city="Berlin"
          href="https://play.google.com/store/apps/details?id=com.feverup.fever&hl=de_DE&gl=DE"
          rel="noreferrer"
          target="_blank"
          className="astro-dwl4onjj"
        >
          {" "}
          <img
            src="/_astro/new-google-play-button.Bev95Nlq.svg"
            alt="Google Play"
            loading="lazy"
            className="astro-dwl4onjj"
          />
        </a>{" "}
      </div>
    </div>
  </div>
  <hr className="fv-footer__line astro-dwl4onjj" />
  <div className="wrapper astro-dwl4onjj">
    <div className="fv-footer__bottom fs-12 astro-dwl4onjj">
      <div className="fv-footer__legals astro-dwl4onjj">
        {" "}
        <a
          className="fv-footer__link astro-dwl4onjj"
          data-footer-link-clicked=""
          data-footer-link-city="Berlin"
          data-testid="footer-legal-link"
          href="/legal/terms_de.html"
          rel="nofollow"
        >
          {" "}
          Allgemeine Geschäftsbedingungen{" "}
        </a>{" "}
        <span className="fv-footer__links-separator astro-dwl4onjj">
          |
        </span>{" "}
        <a
          className="fv-footer__link astro-dwl4onjj"
          data-footer-link-clicked=""
          data-footer-link-city="Berlin"
          data-testid="footer-legal-link"
          href="/legal/privacy_de.html"
          rel="nofollow"
        >
          {" "}
          Datenschutzerklärung{" "}
        </a>{" "}
        <span className="fv-footer__links-separator astro-dwl4onjj">
          |
        </span>{" "}
        <a
          className="fv-footer__link astro-dwl4onjj"
          data-footer-link-clicked=""
          data-footer-link-city="Berlin"
          data-testid="footer-legal-link"
          href="/legal/cookies_de.html"
          rel="nofollow"
        >
          {" "}
          Cookie-Richtlinien{" "}
        </a>{" "}
        <span className="fv-footer__links-separator astro-dwl4onjj">
          |
        </span>{" "}
        <button
          className="fv-footer__link astro-dwl4onjj"
          data-testid="footer-cookies-management"
          data-cookies-management-clicked="https://docs.google.com/document/d/17FTyssWyH8JRpxiO4odyUtVgbECJxpTWV5FYa8B7Qfs/pub"
        >
          Cookie-Verwaltung{" "}
        </button>{" "}
      </div>
      <div className="fv-footer__copyright astro-dwl4onjj">©2024 - Fever </div>
    </div>
  </div>
</footer>

        </>
    )
}
export default FooterContent;